import { render, staticRenderFns } from "./CartPanel_Culinarymobile.vue?vue&type=template&id=1dcaae96&scoped=true&"
import script from "./CartPanel_Culinarymobile.vue?vue&type=script&lang=js&"
export * from "./CartPanel_Culinarymobile.vue?vue&type=script&lang=js&"
import style0 from "./CartPanel_Culinarymobile.vue?vue&type=style&index=0&id=1dcaae96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcaae96",
  null
  
)

export default component.exports